"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LoadingFailed;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FormattedReactMessage = _interopRequireDefault(require("I18n/components/FormattedReactMessage"));

var _UIIllustration = _interopRequireDefault(require("UIComponents/image/UIIllustration"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

function LoadingFailed(props) {
  var className = props.className;
  return _react.default.createElement("div", {
    className: (0, _classnames.default)('loading-failed text-center', className)
  }, _react.default.createElement(_UIIllustration.default, {
    className: "m-y-10",
    name: "errors/general",
    width: 100
  }), _react.default.createElement("h4", null, _I18n.default.text('FileManagerCore.loadFailed.message')), _react.default.createElement("p", null, _I18n.default.text('FileManagerCore.loadFailed.moreInfo'), _react.default.createElement("br", null), _react.default.createElement(_FormattedReactMessage.default, {
    message: "FileManagerCore.loadFailed.tryAgain",
    options: {
      refreshPageLink: _react.default.createElement(_UILink.default, {
        href: ""
      }, _I18n.default.text('FileManagerCore.loadFailed.refreshPageLink')),
      loginLink: _react.default.createElement(_UILink.default, {
        href: "/login"
      }, _I18n.default.text('FileManagerCore.loadFailed.loginLink'))
    }
  })), _react.default.createElement("p", null, _I18n.default.text('FileManagerCore.loadFailed.help')));
}

LoadingFailed.propTypes = {
  className: _propTypes.default.string
};
module.exports = exports.default;